import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import React__default, { useState, useEffect, useRef } from 'react';
import { useUpdateEffect } from 'react-use';
import { P as Popper } from '../Popper-d2ca71bf.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js-stable/instance/concat';
import '@babel/runtime-corejs3/core-js-stable/instance/includes';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/instance/map';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/map';
import '@babel/runtime-corejs3/core-js-stable/set';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/instance/entries';
import '@babel/runtime-corejs3/core-js-stable/instance/flags';
import '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import '@babel/runtime-corejs3/core-js-stable/instance/some';
import '@babel/runtime-corejs3/core-js-stable/object/assign';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/instance/find';
import '@babel/runtime-corejs3/core-js-stable/parse-float';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/promise';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '@babel/runtime-corejs3/core-js-stable/instance/every';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/instance/sort';
import '../clsx.m-7e9a4a81.js';
import 'react-transition-group';
import '@thimble/utility';

var _excluded = ["trigger", "timeout", "onToggle", "children", "visible", "onClose", "closeOnClickOutside", "popup"];

var noop = function noop() {};

var Popover = function Popover(_ref) {
  var trigger = _ref.trigger,
      timeout = _ref.timeout,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? noop : _ref$onToggle,
      children = _ref.children,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _onClose = _ref.onClose,
      closeOnClickOutside = _ref.closeOnClickOutside,
      popup = _ref.popup,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(visible),
      _useState2 = _slicedToArray(_useState, 2),
      localVisible = _useState2[0],
      setLocalVisible = _useState2[1];

  useEffect(function () {
    if (!trigger) {
      setLocalVisible(visible);
    }
  }, [visible, trigger]); // FEAT: trigger onToggle when visiblilty changed

  useUpdateEffect(function () {
    return onToggle(localVisible);
  }, [localVisible]); // FEAT: hoving either triggerEl or hoving popupEl will prevent from closing

  var hovingRef = useRef(false); // FEAT: show & hide, lazy hide

  var hideTimer = useRef();

  var clearHideTimer = function clearHideTimer() {
    return hideTimer.current && clearTimeout(hideTimer.current);
  };

  var show = function show() {
    clearHideTimer();
    setLocalVisible(true);
  };

  var hide = function hide() {
    clearHideTimer();
    hideTimer.current = _setTimeout(function () {
      setLocalVisible(false);
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    }, trigger === 'hover' ? timeout || 500 : timeout || 0);
  }; // FEAT: preset triggers


  var onClick = trigger === 'click' ? function (e) {
    var _children$props$onCli, _children$props;

    localVisible ? hide() : show();
    (_children$props$onCli = (_children$props = children.props).onClick) === null || _children$props$onCli === void 0 ? void 0 : _children$props$onCli.call(_children$props, e);
  } : children.props.onClick; // https://w3c.github.io/uievents/#event-type-mouseenter
  // touch will trigger mouseenter events

  var onMouseEnter = trigger === 'hover' ? function (e) {
    var _children$props$onMou, _children$props2;

    show();
    (_children$props$onMou = (_children$props2 = children.props).onMouseEnter) === null || _children$props$onMou === void 0 ? void 0 : _children$props$onMou.call(_children$props2, e);
  } : children.props.onMouseEnter;
  var onMouseLeave = trigger === 'hover' ? function (e) {
    var _children$props$onMou2, _children$props3;

    hide();
    (_children$props$onMou2 = (_children$props3 = children.props).onMouseLeave) === null || _children$props$onMou2 === void 0 ? void 0 : _children$props$onMou2.call(_children$props3, e);
  } : children.props.onMouseLeave;
  var onFocus = trigger === 'focus' || trigger === 'hover' ? function (e) {
    var _children$props$onFoc, _children$props4;

    show();
    (_children$props$onFoc = (_children$props4 = children.props).onFocus) === null || _children$props$onFoc === void 0 ? void 0 : _children$props$onFoc.call(_children$props4, e);
  } : undefined;
  var onBlur = trigger === 'focus' || trigger === 'hover' ? function (e) {
    var _children$props$onBlu, _children$props5;

    if (!(trigger === 'hover' && hovingRef.current)) hide();
    (_children$props$onBlu = (_children$props5 = children.props).onBlur) === null || _children$props$onBlu === void 0 ? void 0 : _children$props$onBlu.call(_children$props5, e);
  } : undefined;
  return /*#__PURE__*/React__default.createElement(Popper, _extends({}, rest, {
    popup: /*#__PURE__*/React__default.createElement("div", {
      onMouseEnter: trigger === 'hover' ? function () {
        hovingRef.current = true;
        clearHideTimer();
      } : undefined,
      onMouseLeave: trigger === 'hover' ? function () {
        hovingRef.current = false;
        hide();
      } : undefined
    }, popup),
    visible: localVisible,
    onClose: trigger ? hide : _onClose,
    closeOnClickOutside: typeof closeOnClickOutside === 'boolean' ? closeOnClickOutside : trigger !== 'hover'
  }), /*#__PURE__*/React__default.cloneElement(children, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur
  }));
};

export default Popover;
